import {
  ChangeDetectionStrategy,
  Component,
  computed,
  ElementRef,
  input,
  OnInit,
  ViewChild,
  ViewEncapsulation,
} from '@angular/core';
import { SafeHtml } from '@angular/platform-browser';
import { sleep } from '../../../lib/sleep';

@Component({
  selector: 'app-tooltip-content',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
  imports: [],
  templateUrl: './tooltip-content.component.html',
  styleUrl: './tooltip-content.component.scss',
})
export class TooltipContentComponent implements OnInit {
  dark = input<boolean>();
  big = input<boolean>();
  htmlContent = input<SafeHtml>();
  imageOrVideoUrl = input<string>();
  title = input<string>();
  text = input<string>();
  keyboardShortcut = input<string>();
  keyboardShortcutMeta = input<boolean>();
  metaKey = input<string>();
  assetIsVideo = computed(() => this.imageOrVideoUrl()?.endsWith('.mp4'));
  imageUrl = computed(() => (this.assetIsVideo() ? '' : this.imageOrVideoUrl()));
  videoUrl = computed(() => (this.assetIsVideo() ? this.imageOrVideoUrl() : ''));
  @ViewChild('videoEl') videoEl: ElementRef<HTMLVideoElement>;

  async ngOnInit() {
    await sleep(0);
    if (!this.videoEl?.nativeElement?.play) return;
    this.videoEl.nativeElement.muted = true;
    try {
      await this.videoEl.nativeElement.play();
    } catch (e) {
      console.error(e);
    }
  }
}
